import React from "react";
import HeroKube from "../../Components/HeroKube/HeroKube";
import KubeIntro from "../../Components/KubeIntro/KubeIntro";

export default function Kube() {
  return (
    <main>
      <HeroKube />
      <KubeIntro />
    </main>
  );
}